import wall from './wall.png'
import weight from './weight.png'
import end from './end.svg'
import start from './start.png'
import eraser from './eraser.png'

export default {
  wall,
  weight,
  end,
  start,
  eraser,
}